import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Route from '@/routes'

import steps from '@/steps'

import Home from '@/views/Home.vue'
import Step from '@/views/Step.vue'
import Results from '@/views/Results.vue'
import Email from '@/views/Email.vue'
import SendEmail from '@/views/SendEmail.vue'
import EmailDone from '@/views/EmailDone.vue'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    name: Route.home,
    component: Home,
  },
  {
    path: `/${Route.step1}`,
    name: Route.step1,
    component: Step,
    props: () => ({ step: steps.step1 })
  },
  {
    path: `/${Route.step2}`,
    name: Route.step2,
    component: Step,
    props: () => ({ step: steps.step2 })
  },
  {
    path: `/${Route.step3}`,
    name: Route.step3,
    component: Step,
    props: () => ({ step: steps.step3 })
  },
  {
    path: `/${Route.step4}`,
    name: Route.step4,
    component: Step,
    props: () => ({ step: steps.step4 })
  },
  {
    path: `/${Route.step5}`,
    name: Route.step5,
    component: Step,
    props: () => ({ step: steps.step5 })
  },
  {
    path: `/${Route.step6}`,
    name: Route.step6,
    component: Step,
    props: () => ({ step: steps.step6 })
  },
  {
    path: `/${Route.step7}`,
    name: Route.step7,
    component: Step,
    props: () => ({ step: steps.step7 })
  },
  {
    path: `/${Route.results}`,
    name: Route.results,
    component: Results,
  },
  {
    path: `/${Route.email}`,
    name: Route.email,
    component: Email,
  },
  {
    path: `/${Route.send_email}`,
    name: Route.send_email,
    component: SendEmail,
  },
  {
    path: `/${Route.email_done}`,
    name: Route.email_done,
    component: EmailDone,
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return {x: 0, y: 0}
  }
})

export default router
